import { Alert, Paper, Stack, Text, Title } from "@mantine/core";
import type { ReactNode } from "react";

/** Page is a centred form page with a heading; wide forms pass a larger maw. */
export function Page({ title, children, maw = 480 }: { title: string; children: ReactNode; maw?: number }) {
  return (
    <Stack maw={maw} mx="auto" pt={{ base: "md", sm: "lg" }} pb="sm" gap="md">
      <Title order={1} size="h2">
        {title}
      </Title>
      <Paper withBorder p={{ base: "md", sm: "lg" }} radius="md">
        <Stack gap="md">{children}</Stack>
      </Paper>
    </Stack>
  );
}

/** WidePage is a page for lists and tables, with a heading and an optional introduction. */
export function WidePage({ title, intro, children }: { title: string; intro?: ReactNode; children: ReactNode }) {
  return (
    <Stack maw={880} mx="auto" py="xl" gap="lg">
      <Stack gap={4}>
        <Title order={1} size="h2">
          {title}
        </Title>
        {intro ? <Text c="dimmed">{intro}</Text> : null}
      </Stack>
      {children}
    </Stack>
  );
}

export function FormError({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <Alert color="red" role="alert" data-testid="form-error">
      {message}
    </Alert>
  );
}

export function Notice({ children }: { children: ReactNode }) {
  return (
    <Alert color="brand" role="status" data-testid="notice">
      {children}
    </Alert>
  );
}
